const actionTypes = {
    LOAD_SUCCESS: 'homePage/LOAD_SUCCESS'
}

export default actionTypes;